import React, { Component } from 'react'
import qs from 'qs'
import { login } from '../services/auth'
import { Container, Row, Col } from 'reactstrap';
import { LabelErro } from './Layout/LabelErro'
import ReactLoading from "react-loading";
import api from '../services/api'
import { Button, Form } from 'react-bootstrap';
import { URL } from '../constants/index'
import MediaQuery from 'react-responsive';

class Login extends Component {
    constructor(props) {
        super(props)

        this.state = {
            usuario: "",
            senha: "",
            erroLogin: "",
            loading: false,

        }

        this.tratarErroLogin.bind(this)
        this.tratarSucessoLogin.bind(this)
    }

    handleUsuario = e => {
        this.setState({
            usuario: e.target.value
        })
    }

    handleSenha = e => {
        this.setState({
            senha: e.target.value
        })
    }

    validarLogin = e => {
        const { usuario, senha } = this.state;
        if (!usuario || !senha) {
            this.tratarErroLogin("Preencha usuário e senha para continuar");
            return false;
        }

        return true;
    }

    tratarErroLogin(erroLogin) {
        this.setState({
            erroLogin: erroLogin,
            senha: "",
            loading: false
        })
    }

    tratarSucessoLogin(data) {
        login(data)
        this.props.history.push(URL.URLDashboardAtual)
        this.setState({
            loading: false
        })
    }

    onPrimeiroLogin = async e => {
        this.props.history.push(URL.URLPrimeiroLogin)
    }

    onRecuperarSenha = async e => {
        this.props.history.push(URL.URLRecuperarSenha)
    }

    handleLogin = async e => {
        e.preventDefault()
        this.setState({
            loading: true
        })
        const { usuario, senha } = this.state;

        if (!this.validarLogin()) {
            return false;
        }

        api.post("/login/token",
            qs.stringify({
                grant_type: 'password',
                username: usuario,
                password: senha
            }), {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(res => {                  
                this.tratarSucessoLogin(res.data);
            })
            .catch(err => {
                if (err.response && err.response.status === 400) {
                    this.tratarErroLogin(err.response.data.error + " - " + err.response.data.error_description)
                } else {
                    this.tratarErroLogin("Erro ao se comunicar com API de Login")
                }
            });


    }

    render() {
        return (
            <Container style={{ paddingTop: "100px" }}>
                <Row className="justify-content-center">
                    <Col xs="6" style={{ padding: "20px" }} className="border"  >
                        <Form onSubmit={this.handleLogin}>
                            <h3>Login</h3>
                            <h6>Informe seu usuário e senha para ter acesso ao dashboard</h6>
                            <hr />
                            {this.state.erroLogin ? <LabelErro caption={this.state.erroLogin}></LabelErro> : null}
                            <Form.Group controlId="usuario">
                                <Form.Label>Usuario</Form.Label>
                                <Form.Control type="text" placeholder="Usuario" onChange={this.handleUsuario} value={this.state.usuario} />
                            </Form.Group>

                            <Form.Group controlId="senha">
                                <Form.Label>Senha</Form.Label>
                                <Form.Control type="password" placeholder="Senha" onChange={this.handleSenha} value={this.state.senha} />
                            </Form.Group>

                            {!this.state.loading ?

                                <Button variant="dark" type="submit" block>Login</Button>
                                :
                                <Row className="justify-content-center">
                                    <ReactLoading type="bubbles" color="#343a40" height={100} width={100} />
                                </Row>
                            }
                        </Form>
                        <br />
                        <MediaQuery minDeviceWidth={1224}>
                            <Row className="justify-content-center">
                                <Col>
                                    <Button variant="dark" type="submit" onClick={this.onPrimeiroLogin} block>Primeiro Login</Button>
                                </Col>
                                <Col>
                                    <Button variant="dark" type="submit" onClick={this.onRecuperarSenha} block>Recuperar senha</Button>
                                </Col>
                            </Row>
                        </MediaQuery>

                        <MediaQuery maxDeviceWidth={1224}>
                            <Row className="justify-content-center">
                                <Col>
                                    <Button variant="dark" type="submit" onClick={this.onPrimeiroLogin} block>Primeiro Login</Button>
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row className="justify-content-center">
                                <Col>
                                    <Button variant="dark" type="submit" onClick={this.onRecuperarSenha} block>Recuperar senha</Button>
                                </Col>
                            </Row>

                        </MediaQuery>
                    </Col>
                </Row>
            </Container>
        )
    }
}

export default Login;